import { Theme } from "@mui/material";
import { AnnotationOptions } from "chartjs-plugin-annotation";
import {
  MonitoringGraphData,
  thresholdFields,
  ThresholdKeys,
} from "@services/monitoring/types";

const getColorByThreshold = (key: ThresholdKeys, theme: Theme) => {
  switch (key) {
    case "minorThreshold":
      return theme.palette.ticket.Minor.main;
    case "majorThreshold":
      return theme.palette.ticket.Major.main;
    case "criticalThreshold":
      return theme.palette.ticket.Critical.main;
  }
};

const createLineAnnotation = (
  id: number,
  value: number,
  color: string
): AnnotationOptions => {
  return {
    id: String(id),
    type: "line",
    yMax: value,
    yMin: value,
    borderWidth: 1,
    borderColor: color,
    borderDash: [5, 5],
    display: ({ chart }) => chart.isDatasetVisible(id),
  };
};

const getDatasetLines = (
  dataset: MonitoringGraphData,
  datasetIndex: number,
  theme: Theme
) => {
  return thresholdFields.reduce<AnnotationOptions[]>((acc, thresholdField) => {
    const thresholdValue = dataset[thresholdField];

    if (!thresholdValue) return acc;

    const color = getColorByThreshold(thresholdField, theme);

    return [...acc, createLineAnnotation(datasetIndex, thresholdValue, color)];
  }, []);
};

export const getThresholdAnnotations = (
  datasets: MonitoringGraphData[],
  theme: Theme
) => {
  // pass index from dataset as id to have it common for dataset thresholds
  // this allows to hide thresholds related to dataset on label click
  const lines = datasets
    .map((dataset, index) => getDatasetLines(dataset, index, theme))
    .flat();

  return lines.reduce<Record<string, AnnotationOptions>>(
    (acc, lineAnnotation, index) => {
      const id = `line-${index}`;

      acc[id] = lineAnnotation;

      return acc;
    },
    {}
  );
};
